import { PATH_DASHBOARD } from '../routes/paths';

// Redirection Helper Function
export const getListPathForType = (
  type: string,
  ids: string[],
  param_name: string = ''
): string => {
  const encodedIds = ids.map(encodeURIComponent).join(',');
  const paramName = param_name || 'ids';
  return `${dashboardListPathForType(type)}?${paramName}=${encodedIds}`;
};

const dashboardListPathForType = (type: string): string => {
  switch (type.toUpperCase()) {
    case 'STUDENT':
      return `${PATH_DASHBOARD.student.list}`;
    case 'TOUR':
      return `${PATH_DASHBOARD.tour.list}`;
    case 'TOUR_PLAN':
      return `${PATH_DASHBOARD.tourPlan.list}`;
    default:
      return '';
  }
};
